import { render, staticRenderFns } from "./ShippingLogBLDetailPop.vue?vue&type=template&id=53d62a0e"
import script from "./ShippingLogBLDetailPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLDetailPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d62a0e')) {
      api.createRecord('53d62a0e', component.options)
    } else {
      api.reload('53d62a0e', component.options)
    }
    module.hot.accept("./ShippingLogBLDetailPop.vue?vue&type=template&id=53d62a0e", function () {
      api.rerender('53d62a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLDetailPop.vue"
export default component.exports